import { useProductContext } from '../../../context/ProductContext';
import { useEffect, useState } from 'react';

export const useAnalyticsProductUpdate = () => {
  const { products: allProducts } = useProductContext();

  const [products, setProducts] = useState(allProducts);

  useEffect(() => {
    if (JSON.stringify(products) !== JSON.stringify(allProducts)) {
      setProducts(allProducts);
    }
  }, [allProducts]);

  return {
    products: products,
  };
};
